import React from "react";
import "./notfound.scss";

function Notfound() {
  return (
    <div className="not-found">
      <h1>404 | Not Found</h1>
    </div>
  );
}

export default Notfound;
